<template>
  <div>
    <c-card title="장치 및 설비 목록 업로드 (일괄업로드는 신규로만 저장이 됩니다.)" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="LBLAPPLY" 
            icon="save"
            @btnClicked="acceptData" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-3">
          <c-plant :editable="false" type="edit" name="plantCd" v-model="data.plantCd" />
        </div>
      </template>
    </c-card>
    <c-excel-upload 
      :editable="editable"
      :excelUploadInfo="excelUploadInfo"
    />
  </div>
</template>

<script>
export default {
  name: 'device-equipment-excel-upload',
  data() {
    return {
      data: {
        plantCd: null,  // 사업장코드
      },
      headerUrl: '',
      excelUploadInfo: {
        rowKeys: ['equipmentNo','devicePartName'], // 데이터들의 키 속성값
        taskClassCd: 'PSI_DEVICE_EQUIPMENT_UPLOAD', // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [[
          {
            name: 'plantCd',
            label: '사업장',
            align: 'center',
            style: 'width:110px',
            type: 'plant',
            sortable: false,
          },
          {
            name: 'equipmentNo',
            label: '장치번호',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'deviceName',
            label: '장치명',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'devicePartName',
            label: '장치구분',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'inMaterials',
            label: '내용물',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'volume',
            label: '용량',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'pressOperation',
            label: '운전압력(MPa)',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'pressDesign',
            label: '설계압력(MPa)',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'tempOperation',
            label: '운전온도(℃)',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'tempDesign',
            label: '설계온도(℃)',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'materialMain',
            label: '사용재질본체',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'materialSubPart',
            label: '사용재질부속품',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'materialGasket',
            label: '사용재질개스킷',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'weldingEfficiency',
            label: '용접효율',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'calculateThick',
            label: '계산두께(mm)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'corrosionAllowance',
            label: '부식여유(mm)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'useThick',
            label: '사용두께(mm)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'afterHeatTreatYn',
            label: '후열처리여부',
            align: 'center',
            sortable: false,
          },
          {
            name: 'nondestructPercent',
            label: '비파괴검사율(%)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'applicableLaws',
            label: '적용법령',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'deptName',
            label: '관리부서명',
            deptCd: 'deptCd',
            align: 'center',
            style: 'width:250px',
            type: 'dept',
            sortable: false,
          },
        ]],
        data: [],
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (!this.excelUploadInfo.data[0] || this.excelUploadInfo.data[0].length === 0) {
          dataCntCheck = false;
        }
        if (this.$_.findIndex(this.excelUploadInfo.data[0], (item) => { return item.error_message }) > -1) {
          errorDataCheck = true
        }

        if (!dataCntCheck) {
          window.getApp.$emit('ALERT', {
            title: 'LBLGUIDE', // 안내
            message: '업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: '에러가 있는 데이터가 존재합니다.\n\r데이터 확인 후 적용하시길 바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: '해당 엑셀데이터를 업로드하면, 신규데이터로 저장되고, 동일한 장치는 수정됩니다. \n\r적용하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수  
              confirmCallback: () => {
                this.$emit('closePopup', this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }
      }
    }
  }
};
</script>
